<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconEmoji_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M5.25 5.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m6.434 5.478c-.041.092-1.051 2.272-3.684 2.272s-3.643-2.18-3.684-2.272a.75.75 0 1 1 1.368-.614c.024.051.67 1.386 2.316 1.386s2.292-1.335 2.318-1.393a.75.75 0 0 1 .993-.366.75.75 0 0 1 .373.987M10.75 8a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
    />
</svg>
